import { useMemo } from 'react';

export const useViewProps = ({ form_state, viewProps, propSectionProps }) => {

  const { formKey, viewItem, formProps, dataOptions, swipedItem, allowImage, isDataContext, isViewSettingsContext } = form_state ?? {}

  // console.log('viewItem', viewItem)

  const normalProps = useMemo(() => {

    if (viewItem?.propSections) {
      // const zzzz = _.groupBy(viewProps, 'propSection') 
      const _normalProps = getNormalProps(viewItem, viewProps, formProps, dataOptions, swipedItem, allowImage, isDataContext, isViewSettingsContext)
      return _normalProps
    } else if (viewProps) {
      const _normalProps = getNormalProps(viewItem, viewProps, formProps, dataOptions, swipedItem, allowImage, isDataContext, isViewSettingsContext)
      return _normalProps
    }
  }, [viewProps, formKey])

  return { viewProps_normal: normalProps, propSectionProps }

};

const getNormalProps = (viewItem, viewProps, formProps, dataOptions, swipedItem, allowImage, isDataContext, isViewSettingsContext) => {

  addAdditionalProps(swipedItem, viewProps, viewItem, dataOptions, allowImage)

  const { editableItem } = formProps ?? {}

  let props_normal;

  if (isViewSettingsContext) {
    props_normal = { ...viewProps }
  } else if (isDataContext && !editableItem) {
    const { props } = viewItem ?? {}
    props_normal = { ...viewProps }
  } else {
    props_normal = { ...viewProps }
  }
  return props_normal
}

const addAdditionalProps = async (swipedItem, viewProps, viewItem, dataOptions, allowImage, isDataItem, ignoreItemStatus_p) => {

  const { propsAdditional } = viewItem ?? {}
  const { ignoreItemStatus, showPdf } = propsAdditional ?? {}
  const { useItemStatus, useItemTimezone, timezoneCollections } = dataOptions ?? {}

  const allowItemStatus = useItemStatus && !ignoreItemStatus && isDataItem && !ignoreItemStatus_p && viewItem
  const allowTimezone = useItemTimezone && timezoneCollections && !ignoreItemStatus && isDataItem && !ignoreItemStatus_p && viewItem && timezoneCollections.includes(viewItem.key)

  if (swipedItem && swipedItem.dKey) {
    switch (swipedItem.dKey) {
      case 'events':
        viewProps['eventStatusType'] = settingsHelpers.newPropEditItem('eventStatusType', gEnums.formItemTypes.select, listTypes.eventStatusTypes, 'status', 'status')
        if (viewItem) {
          viewItem.propSections['status'] = {
            key: 'status',
            postion: viewItem.propSections.length,
            show: true,
            showDesktop: true,
          }
        }
        break;
      default:
      // nothing
    }
  } else {
    if (showPdf) { addPropItem(viewItem, viewProps, 'itemPdf', propDataOpts(false, gEnums.formItemTypes.select, dynListTypes.itemPdf)) }
    if (allowItemStatus) { addPropItem(viewItem, viewProps, 'itemStatusType', propDataOpts(false, gEnums.formItemTypes.select, listTypes.statusTypes)) }
    if (allowTimezone) { addPropItem(viewItem, viewProps, 'timezone', propDataOpts(false, gEnums.formItemTypes.select, listTypes.timeZones)) }
  }

  if (allowImage) { viewProps['fileImage'] = addImageProp('fileImage', Object.keys(viewProps).length) }

}

const addImageProp = (key, existingCount) => {
  return {
    position: existingCount ? existingCount : 2,
    show: true,
    display: {
      caption: _.startCase(key),
    },
    data: {
      formItemType: gEnums.formItemTypes.fileItemSelect
    },
    propSection: 'details'
  }
}
